module.exports = __webpack_public_path__ + "static/media/elephant.d676f4e6.svg";